import { createBrowserRouter } from 'react-router-dom';
import RouterErrorBoundary from '@/components/common/RouterErrorBoundary.tsx';
import {
    PATH_AI_CHAT,
    PATH_AI_CHAT_HISTORY,
    PATH_AI_ENTRY,
} from '@/router/routes.ts';
import AiChatEntry from '@/pages/ai-chat/AiChatEntry.tsx';
import AiChat from '@/pages/ai-chat/AiChat.tsx';
import AiChatHistory from '@/pages/ai-chat/AiChatHistory.tsx';

export const ROUTES = [
    {
        path: '/',
        errorElement: <RouterErrorBoundary />,
        children: [
            // ai智答
            { path: PATH_AI_ENTRY, element: <AiChatEntry /> },
            { path: PATH_AI_CHAT, element: <AiChat /> },
            { path: PATH_AI_CHAT_HISTORY, element: <AiChatHistory /> },
            {
                path: '*',
                element: <RouterErrorBoundary status={404} />,
            },
        ],
    },
];

// 路由配置
export const ROUTERS = createBrowserRouter(ROUTES);
